export default __webpack_public_path__ + "static/media/38.51f830e7.png";